module.exports = {
	init: function ($) {
		this.xtoLoadVideoAssets()
			.then(() => {
				this.xtoSetupPlayers($)
			})
			.catch((error) => {
				console.error('Video assets error', error)
			})
	},

	xtoLoadVideoAssets: function () {
		const promises = []

		if (typeof window.Vimeo === 'undefined') {
			promises.push(this.xtoLoadScript('https://player.vimeo.com/api/player.js'))
		}

		if (typeof window.Plyr === 'undefined') {
			promises.push(this.xtoLoadScript('https://cdn.plyr.io/3.8.4/plyr.polyfilled.js'))
		}

		if (!document.querySelector('link[data-plyr-css]')) {
			this.xtoLoadStyle('https://cdn.plyr.io/3.8.4/plyr.css')
		}

		return Promise.all(promises)
	},

	xtoLoadScript: function (src) {
		return new Promise((resolve, reject) => {
			const existing = document.querySelector('script[src="' + src + '"]')

			if (existing) {
				if (existing.dataset.loaded === 'true') {
					resolve()
					return
				}

				existing.addEventListener('load', resolve)
				existing.addEventListener('error', reject)

				return
			}

			const script = document.createElement('script')
			script.src = src
			script.async = true

			script.addEventListener('load', () => {
				script.dataset.loaded = 'true'
				resolve()
			})

			script.addEventListener('error', reject)

			document.body.appendChild(script)
		})
	},

	xtoLoadStyle: function (href) {
		const link = document.createElement('link')

		link.rel = 'stylesheet'
		link.href = href
		link.dataset.plyrCss = 'true'

		document.head.appendChild(link)
	},

	xtoSetupPlayers: function ($) {
		const players = document.querySelectorAll('.js-xto-vimeo-player')

		console.log('Plyr players found', players.length)

		if (typeof window.Plyr === 'undefined') {
			console.error('Plyr is not loaded')
			return
		}

		if (typeof window.Vimeo === 'undefined') {
			console.error('Vimeo Player SDK is not loaded')
			return
		}

		players.forEach((playerElement) => {
			if (playerElement.dataset.initialized === 'true') {
				return
			}

			const container = playerElement.closest('.xto-video')

			if (!container) {
				console.error('Video container not found')
				return
			}

			playerElement.dataset.initialized = 'true'

			const plyr = new window.Plyr(playerElement, {
				controls: [
					'play-large',
					'play',
					'progress',
					'current-time',
					'duration',
					'mute',
					'volume',
					'captions',
					'settings',
					'fullscreen',
				],
				settings: ['speed'],
				speed: {
					selected: 1,
					options: [0.75, 1, 1.25, 1.5, 2],
				},
				ratio: '16:9',
				clickToPlay: true,
				hideControls: true,
				resetOnEnd: false,
			})

			const initialTime = Number(container.dataset.timeView || 0)

			let lastSavedAt = 0
			let initialTimeApplied = false
			let vimeo = null

			const getCurrentIframe = () => {
				return container.querySelector('.plyr iframe') || container.querySelector('iframe')
			}

			const getVimeoPlayer = () => {
				if (vimeo) {
					return vimeo
				}

				const iframe = getCurrentIframe()

				if (!iframe) {
					return null
				}

				vimeo = new window.Vimeo.Player(iframe)
				container.xtoVimeo = vimeo

				return vimeo
			}

			const xtoEnableHiddenVimeoTrack = (enablePlyrCaptions = false) => {
				const vimeoPlayer = getVimeoPlayer()

				if (!vimeoPlayer) {
					return
				}

				vimeoPlayer
					.ready()
					.then(() => vimeoPlayer.getTextTracks())
					.then((tracks) => {
						if (!tracks || !tracks.length) {
							return
						}

						const track =
							tracks.find((item) => item.language === 'es') ||
							tracks.find(
								(item) => item.language && item.language.startsWith('es'),
							) ||
							tracks[0]

						if (!track) {
							return
						}

						return vimeoPlayer
							.enableTextTrack(track.language, track.kind, false)
							.then(() => {
								if (!enablePlyrCaptions) {
									return
								}

								plyr.captions.active = true

								if (plyr.elements.container) {
									plyr.elements.container.classList.add('plyr--captions-active')
								}

								if (plyr.elements.buttons.captions) {
									plyr.elements.buttons.captions.classList.add(
										'plyr__control--pressed',
									)
									plyr.elements.buttons.captions.setAttribute(
										'aria-pressed',
										'true',
									)
								}
							})
					})
					.catch((error) => {
						console.error('Vimeo hidden captions error', error)
					})
			}

			const updateSectionDuration = () => {
				const vimeoPlayer = getVimeoPlayer()

				if (!vimeoPlayer) {
					return
				}

				vimeoPlayer
					.ready()
					.then(() => vimeoPlayer.getDuration())
					.then((duration) => {
						this.xtoUpdateSectionDuration(container, duration)
					})
					.catch(() => {})
			}

			const applyInitialTime = () => {
				if (initialTimeApplied || !initialTime || initialTime <= 0) {
					return
				}

				const vimeoPlayer = getVimeoPlayer()

				if (!vimeoPlayer) {
					return
				}

				vimeoPlayer
					.ready()
					.then(() => vimeoPlayer.getDuration())
					.then((duration) => {
						const safeDuration = Math.floor(duration || 0)
						const safeTime =
							safeDuration > 0 ? Math.min(initialTime, safeDuration - 2) : initialTime

						return vimeoPlayer.setCurrentTime(safeTime).then(() => {
							initialTimeApplied = true

							this.xtoUpdatePlyrTimeUi(container, safeTime, safeDuration)

							console.log('Initial time applied with Vimeo SDK', {
								course: container.dataset.course,
								section: container.dataset.section,
								initialTime: safeTime,
								duration: safeDuration,
							})
						})
					})
					.catch((error) => {
						console.error('Error setting initial time with Vimeo SDK', error)
					})
			}

			plyr.on('ready', () => {
				console.log('Plyr ready', {
					course: container.dataset.course,
					section: container.dataset.section,
					initialTime: initialTime,
				})

				updateSectionDuration()

				setTimeout(() => {
					xtoEnableHiddenVimeoTrack(true)
				}, 300)

				setTimeout(applyInitialTime, 500)
				setTimeout(applyInitialTime, 1200)
				setTimeout(applyInitialTime, 2500)
			})

			plyr.on('captionsenabled', () => {
				setTimeout(() => {
					xtoEnableHiddenVimeoTrack()
				}, 50)
			})

			plyr.on('play', () => {
				applyInitialTime()

				setTimeout(() => {
					xtoEnableHiddenVimeoTrack()
				}, 100)
			})

			plyr.on('timeupdate', () => {
				const time = Math.floor(plyr.currentTime || 0)
				const duration = Math.floor(plyr.duration || 0)

				if (!time || !duration) {
					return
				}

				if (time - lastSavedAt < 10 && time < duration - 2) {
					return
				}

				lastSavedAt = time

				this.xtoSaveDisplayedTime($, container, time, duration)
			})

			plyr.on('ended', () => {
				const time = Math.floor(plyr.currentTime || plyr.duration || 0)
				const duration = Math.floor(plyr.duration || 0)

				this.xtoSaveDisplayedTime($, container, time, duration)
			})

			container.xtoPlyr = plyr
		})
	},

	xtoFormatTime: function (seconds) {
		const totalSeconds = Math.max(0, Math.floor(seconds || 0))
		const minutes = Math.floor(totalSeconds / 60)
		const remainingSeconds = totalSeconds % 60

		return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
	},

	xtoUpdatePlyrTimeUi: function (container, time, duration) {
		const safeTime = Math.floor(time || 0)
		const safeDuration = Math.floor(duration || 0)
		const percent = safeDuration > 0 ? Math.min((safeTime / safeDuration) * 100, 100) : 0

		const currentTime = container.querySelector('.plyr__time--current')
		const seek = container.querySelector('input[data-plyr="seek"]')

		if (currentTime) {
			currentTime.textContent = this.xtoFormatTime(safeTime)
		}

		if (seek) {
			seek.value = percent
			seek.setAttribute('aria-valuenow', safeTime)
			seek.setAttribute(
				'aria-valuetext',
				`${this.xtoFormatTime(safeTime)} of ${this.xtoFormatTime(safeDuration)}`,
			)
			seek.style.setProperty('--value', `${percent}%`)
		}
	},

	xtoFormatDurationLabel: function (seconds) {
		const totalSeconds = Math.max(0, Math.floor(seconds || 0))
		const minutes = Math.floor(totalSeconds / 60)
		const remainingSeconds = totalSeconds % 60

		if (minutes <= 0) {
			return remainingSeconds + ' segundos'
		}

		if (remainingSeconds <= 0) {
			return minutes + ' Minutos'
		}

		return minutes + ':' + String(remainingSeconds).padStart(2, '0') + ' Minutos'
	},

	xtoUpdateSectionDuration: function (container, duration) {
		const section = container.closest('.course-section__item')

		if (!section) {
			return
		}

		const durationText = section.querySelector('.course-section__duration-text')

		if (!durationText) {
			return
		}

		durationText.textContent = this.xtoFormatDurationLabel(duration)
	},

	xtoSaveDisplayedTime: function ($, container, time, duration) {
		const course = container.dataset.course
		const section = container.dataset.section

		console.log('Saving displayed time', {
			course: course,
			section: section,
			time: time,
			duration: duration,
			ajax: typeof xto_ajax !== 'undefined',
		})

		if (
			!course ||
			section === undefined ||
			section === null ||
			typeof xto_ajax === 'undefined'
		) {
			console.error('Missing data for saving displayed time', {
				course: course,
				section: section,
				xto_ajax: typeof xto_ajax,
			})

			return
		}

		$.ajax({
			url: xto_ajax.ajax_url,
			type: 'post',
			data: {
				action: 'set_displayed_time',
				course: course,
				video: section,
				time: time,
				duration: duration,
			},
			success: function (response) {
				console.log('Displayed time saved', response)
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.error('Displayed time AJAX error', textStatus, errorThrown)
			},
		})
	},
}
